import * as e from "react";
import { forwardRef as C } from "react";
const a = C(
  function(t, l) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: l,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8.45833 16.4166H1M8.45833 16.4166L6.97518 18.3731C6.67585 18.768 6.20892 19 5.71342 19H3.5M8.45833 16.4166L10.4792 14.4583L12.3233 12.6713C12.4213 12.5762 12.5775 12.5775 12.674 12.674L13.75 13.75L14.8667 14.8667C14.9456 14.9456 15.0673 14.9626 15.1648 14.9084L19.5 12.5",
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 2
        }
      ), /* @__PURE__ */ e.createElement("circle", { cx: 12.375, cy: 8.375, fill: "#FFCA00", r: 2.375 }), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M18.9281 7.9699C19.0433 7.70383 20.2125 7.19906 21.2 7.62669C22.1875 8.05431 22.6654 9.14596 22.5041 9.51846C22.3428 9.89096 21.2196 10.2893 20.2321 9.86168C19.6454 9.60759 19.2548 9.08146 19.0586 8.64048L19.0313 8.5766C18.9189 8.30276 18.8847 8.07016 18.9281 7.9699Z",
          fill: "#815337",
          stroke: "#815337",
          strokeWidth: 0.626807
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M21.6254 9.71715C21.6376 9.47232 21.6671 9.29413 21.7175 9.17764C21.768 9.06115 21.8777 8.91773 22.0479 8.7413C22.0964 8.69122 22.1764 8.6905 22.2266 8.73889C22.2766 8.78734 22.2782 8.86704 22.2299 8.91716L22.1729 8.97752L22.121 9.03481C22.0328 9.13583 21.9755 9.21785 21.9494 9.27807C21.9234 9.33829 21.9027 9.4362 21.8894 9.56963L21.8831 9.64667C21.8812 9.67315 21.8795 9.70077 21.8781 9.72953C21.8746 9.79909 21.8153 9.85239 21.7458 9.84908C21.6762 9.84561 21.622 9.78674 21.6254 9.71715ZM19.2052 8.74962C19.1552 8.70117 19.1544 8.6211 19.2027 8.57099C19.3535 8.4147 19.4476 8.29222 19.4832 8.21008C19.5188 8.12792 19.5437 7.9755 19.5545 7.75862C19.558 7.68896 19.6172 7.63559 19.6868 7.63907C19.7564 7.6426 19.8099 7.70173 19.8064 7.77136C19.7941 8.01602 19.7646 8.19443 19.7142 8.31087C19.6637 8.42719 19.5541 8.56996 19.3843 8.74594C19.3359 8.79614 19.2554 8.79804 19.2052 8.74962Z",
          fill: "#815337"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.9297 8.40364C19.9554 8.34421 20.0214 8.3146 20.0819 8.33287L20.0958 8.33794L21.4368 8.91865C21.5008 8.94636 21.5302 9.02072 21.5025 9.08472C21.4767 9.14415 21.4108 9.17376 21.3503 9.1555L21.3364 9.15042L19.9954 8.56972C19.9314 8.542 19.902 8.46765 19.9297 8.40364Z",
          fill: "#815337"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M20.25 8.27696C20.2777 8.21295 20.3521 8.18354 20.4161 8.21125C20.4755 8.23699 20.5051 8.30294 20.4869 8.36347L20.4818 8.37733L20.2882 8.82432C20.2605 8.88833 20.1861 8.91774 20.1221 8.89003C20.0627 8.86429 20.0331 8.79834 20.0514 8.73781L20.0564 8.72396L20.25 8.27696Z",
          fill: "#815337"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M20.697 8.47032C20.7247 8.40631 20.7991 8.37689 20.8631 8.40461C20.9225 8.43035 20.9521 8.4963 20.9339 8.55683L20.9288 8.57068L20.7352 9.01768C20.7075 9.08169 20.6332 9.1111 20.5692 9.08339C20.5097 9.05765 20.4801 8.9917 20.4984 8.93117L20.5035 8.91731L20.697 8.47032Z",
          fill: "#815337"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M21.0265 8.34409C21.0542 8.28009 21.1286 8.25067 21.1926 8.27839C21.252 8.30413 21.2816 8.37008 21.2633 8.43061L21.2583 8.44446L21.0647 8.89146C21.037 8.95547 20.9626 8.98488 20.8986 8.95717C20.8392 8.93143 20.8096 8.86548 20.8279 8.80495L20.8329 8.79109L21.0265 8.34409Z",
          fill: "#815337"
        }
      ), /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M14.2929 10.2929L13.5858 11L15 12.4142L15.7071 11.7071L14.2929 10.2929ZM17.7071 9.70711C18.0976 9.31658 18.0976 8.68342 17.7071 8.29289C17.3166 7.90237 16.6834 7.90237 16.2929 8.29289L17.7071 9.70711ZM15 11L15.7071 11.7071L17.7071 9.70711L17 9L16.2929 8.29289L14.2929 10.2929L15 11Z",
          fill: "#FFCA00"
        }
      )),
      /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement(
        "rect",
        {
          fill: "#fff",
          height: 15,
          transform: "translate(0 5)",
          width: 24
        }
      )))
    );
  }
);
export {
  a as BetBuilderBadgeAmericanReceivingActive
};
